<template>
  <div class="span-filter">
    <!-- 彩种选择 -->
    <el-form :inline="true" size="mini" label-width="80px">
      <el-row :gutter="20" class="first-row">
        <el-col :span="6">
          <el-form-item label="彩种">
            <el-select v-model="selectedGame" placeholder="选择彩种" @change="onGameChange">
              <el-option
                v-for="game in gameOptions"
                :key="game.value"
                :label="game.label"
                :value="game.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 四个跨度 + 查询/重置按钮 -->
      <el-row :gutter="20" class="filter-row" style="margin-top:10px;">
        <el-col :span="4">
          <el-form-item label="总跨度">
            <el-input
              v-model="filters.kua"
              placeholder="0-9"
              maxlength="1"
              oninput="this.value=this.value.replace(/[^0-9]/g,'').slice(0,1)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="百十跨度">
            <el-input
              v-model="filters.kua_bs"
              placeholder="0-9"
              maxlength="1"
              oninput="this.value=this.value.replace(/[^0-9]/g,'').slice(0,1)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="十个跨度">
            <el-input
              v-model="filters.kua_sg"
              placeholder="0-9"
              maxlength="1"
              oninput="this.value=this.value.replace(/[^0-9]/g,'').slice(0,1)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="百个跨度">
            <el-input
              v-model="filters.kua_bg"
              placeholder="0-9"
              maxlength="1"
              oninput="this.value=this.value.replace(/[^0-9]/g,'').slice(0,1)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4" class="button-col">
          <el-button type="primary" @click="filterData" style="margin-right:10px;">查询</el-button>
          <el-button @click="resetFilters">重置</el-button>
        </el-col>
      </el-row>
    </el-form>

    <!-- 数据表格，带 loading -->
    <el-table
      :data="filteredData"
      border
      stripe
      style="width: 100%; margin-top: 20px;"
      v-loading="loading"
      element-loading-text="数据加载中..."
    >
      <el-table-column prop="lottery_no" label="期号" width="150" />
      <el-table-column label="中奖号码" >
        <template slot-scope="scope">
          {{ scope.row.lottery_res_red ? scope.row.lottery_res_red.join(',') : '' }}
        </template>
      </el-table-column>
      <el-table-column prop="red_kua" label="总跨度" width="100" />
      <el-table-column prop="red_kua_bs" label="百十跨度" width="100" />
      <el-table-column prop="red_kua_sg" label="十个跨度" width="100" />
      <el-table-column prop="red_kua_bg" label="百个跨度" width="100" />
    </el-table>
  </div>
</template>

<script>
import { getScanFilerData } from '@/api/tool'

export default {
  name: 'SpanFilter',
  data() {
    return {
      gameOptions: [
        { label: '福彩3D', value: 5 },
        { label: '排列三', value: 6 },
      ],
      selectedGame: 5, // 默认彩种

      filters: {
        kua: '',
        kua_bs: '',
        kua_sg: '',
        kua_bg: ''
      },

      filteredData: [],
      loading: false
    };
  },
  mounted() {
    // this.fetchData();
  },
  methods: {
    onGameChange() {
      this.resetFilters();
    },

    buildParams() {
      const params = { lottery_id: this.selectedGame };
      // 只加非空字段
      Object.keys(this.filters).forEach(key => {
        if (this.filters[key] !== '' && this.filters[key] !== null) {
          params[key] = this.filters[key];
        }
      });
      return params;
    },

    fetchData() {
      const { totalSpan, hundredsSpan, tensSpan, unitsSpan } = this.filters;
      if (
        (totalSpan === '' || totalSpan === null) &&
        (hundredsSpan === '' || hundredsSpan === null) &&
        (tensSpan === '' || tensSpan === null) &&
        (unitsSpan === '' || unitsSpan === null)
      ) {
        this.$message.warning('请至少输入一个跨度值');
        return;
      }
      this.loading = true;
      const params = this.buildParams();
      getScanFilerData(params)
        .then(res => {
             let list = (res.data && res.data.data) || [];
             this.filteredData = list.map(item => {
               return {
                 ...item,
                 // 前缀加 "20"
                 lottery_no: `20${item.lottery_no}`,
                 // 确保是数组
                 lottery_res_red: typeof item.lottery_res_red === 'string'
                   ? item.lottery_res_red.split(',')
                   : item.lottery_res_red
               };
             });
           })
           .catch(err => {
             console.error('获取数据失败', err);
             this.filteredData = [];
           })
           .finally(() => {
             this.loading = false;
           });
    },

    filterData() {
      // 校验：四个跨度至少填一个
      const { kua, kua_bs, kua_sg, kua_bg } = this.filters;
      if (!kua && !kua_bs && !kua_sg && !kua_bg) {
        this.$message.error('请至少输入一个跨度值 (0-9)');
        return;
      }
      this.fetchData();
    },

    resetFilters() {
      this.filters = {
        kua: '',
        kua_bs: '',
        kua_sg: '',
        kua_bg: ''
      };
      // this.fetchData();
      this.filteredData = []
    }
  }
};
</script>

<style scoped>
.span-filter {
  padding: 20px;
}

.filter-row {
  display: flex;
  align-items: center; /* 保证列垂直居中 */
}

.button-col {
  display: flex;
  align-items: center;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/usingTools/spanFilter.vue